// framework/client/core/ClientCommandHandler.js
import { ComponentBase } from "./ComponentBase.js";

export class ClientCommandHandler extends ComponentBase {
    constructor(config) {
        super(config);
        this.commandHandlers = {
            'navigate': this.handleNavigate.bind(this),
            'show-toast': this.handleShowToast.bind(this), // Example
            // Add more command handlers here
        };
    }

    async initialize() {
        this.log.info("Initializing ClientCommandHandler");
        this.appClient.events.server.on("client-command", this.handleClientCommand.bind(this));
    }

    registerCommand(command, handler) {
        this.commandHandlers[command] = handler;
    }

    unregisterCommand(command) {
        delete this.commandHandlers[command];
    }

    async handleClientCommand(eventPayload) {
        const { command, args, responseEventId } = eventPayload;

        if (!command) {
            this.log.warn("Received client-command without command.");
            return;
        }

        const handler = this.commandHandlers[command];
        if (handler) {
            try {
                const response = await handler(args);
                this.submitResponse(responseEventId, response);
            } catch (error) {
                this.log.error(`Error executing command '${command}':`, error);
                this.submitResponse(responseEventId, { success: false, error: error.message });
            }
        } else {
            this.log.warn(`Unknown client command: ${command}`);
            this.submitResponse(responseEventId, { success: false, error: `Unknown command: ${command}` });
        }
    }

    async submitResponse(responseEventId, response) {
        await this.appClient.rpcClient.call('SystemRpc.submitCommandResponse', {
            responseEventId,
            response
        });
    }

    async handleNavigate(args) {
        const { routePath } = args;
        if (!routePath) {
            throw new Error("Navigate command requires a 'routePath' argument.");
        }
        this.appClient.layoutEngine.navigate(routePath);
        return { success: true, message: `Navigated to ${routePath}` };
    }

    async handleShowToast(args) {
        const { message, type } = args;
        this.appClient.notifier.notify(message, { type: type || 'info' });
        return { success: true, message: 'Toast displayed.' };
    }

}